import React from 'react'
import * as R from 'ramda'

import transact from 'src/lib/data/transact'
import { fetchMetrics } from 'src/lib/data/metrics'
import { board as actions } from '../actions'

import * as modalActions from 'src/store/action-methods/modal'

import * as selectors from '../selectors/board'

import { fetchEntity } from 'src/store/db/thunks/base'

export const initialState = {
  id: null,
  title: '',
  followers: [],
  admins: [],
  feed: [],
  feedLength: null,
  feedCollapsed: false,
  newPosts: [],
  ':board/settings': {
    // TODO: remove?
    ':board-settings/read-only': false
  },
  ':board/pinned-to-top': null,
  ':board/share-tokens': [],
  settings: {
    points: {
      predicates: []
    }
  },
  dashboard: {
    chartData: [],
    dateRange: {},
    user: null
  },
  topics: [],
  badges: [],
  isMetricsLoading: false,
  ':board/grading-periods': [],
  controlsInView: true,
  '@board/metrics': {},
  postsInView: []
}

export const setBoard =
  (board, ops = {}) =>
  dispatch =>
    dispatch({
      type: actions.SET_BOARD,
      board,
      ops
    })

export const setFeatures = features => dispatch =>
  dispatch({
    type: actions.SET_BOARD_FEATURES,
    payload: features
  })

export const setNudgeSettings = nudgeSettings => dispatch =>
  dispatch({
    type: actions.SET_NUDGE_SETTINGS,
    payload: nudgeSettings
  })

export const setDashboard = (chartData, newDateRange, userId) => dispatch =>
  dispatch({
    type: actions.SET_DASHBOARD,
    chartData,
    newDateRange,
    userId
  })

export const setDateRange = dateRange => dispatch =>
  dispatch({
    type: actions.SET_DATERANGE,
    dateRange
  })

export const removeDashboardLabel = label => dispatch =>
  dispatch({
    type: actions.REMOVE_DASHBOARD_LABEL,
    label
  })

export const updateGroupName = payload => dispatch =>
  dispatch({
    type: actions.UPDATE_GROUP_NAME,
    payload
  })

export const setBoardGroups = payload => dispatch =>
  dispatch({
    type: actions.SET_BOARD_GROUPS,
    payload
  })

export const addActivities = payload => dispatch =>
  dispatch({
    type: actions.ADD_ACTIVITIES,
    payload
  })

export const setDisabledEmojis = payload => dispatch =>
  dispatch({
    type: actions.SET_DISABLED_EMOJIS,
    payload
  })

function showPointCongratsModal(setModal) {
  const title = 'Hooray!'

  const body = (
    <div>
      <div className="my-8"> 🎉 Yay 🎉</div>
      <p>
        You&apos;ve reached the maximum number of points you can earn this week.
      </p>
      <div className="my-8">Nice Work!</div>
    </div>
  )
  const opts = {
    open: true,
    large: true,
    title,
    body
  }
  setModal(opts)
}

export const updatePointsMetrics = () => async (dispatch, getState) => {
  const { board, user } = getState()
  if (!R.path([':board/settings', ':board-settings/grading-enabled'], board)) {
    return
  }
  const [prevScore, prevGoal] = board['@board/metrics'].weeklyScore
  const atMax = prevScore >= prevGoal

  dispatch(setBoard({ isMetricsLoading: true }))

  const metrics = await dispatch(fetchMetrics(board))
  const [score, goal] = metrics['@board/metrics'].weeklyScore
  const pointAdjustment = metrics['@board/metrics'].extraCredit || 0

  if (score >= goal + pointAdjustment && !atMax) {
    const setModal = payload => dispatch(modalActions.setModal(payload))
    showPointCongratsModal(setModal)
  }

  dispatch(setBoard({ isMetricsLoading: false }))
  dispatch({
    type: actions.UPDATE_POINT_METRICS,
    metrics
  })

  dispatch(setBoard({ '@board/metrics': metrics['@board/metrics'] }))
  dispatch(
    fetchEntity({
      eid: board[':db/id'],
      query: [
        ':db/id',
        {
          '@board/metrics': {},
          '@board/grouped-log :as log': { userId: user[':db/id'] }
        }
      ]
    })
  )
}

export const addShareToken = (boardId, value) => async dispatch => {
  if (!value) {
    throw new Error('Please enter a valid share link path.')
  }
  if (value.length < 6) {
    throw new Error('Share link paths must have at least 6 characters.')
  }

  const res = await transact([['@board/add-share-token', { boardId, value }]], {
    alwaysThrow: true
  })
  const realNewToken = R.assoc(
    ':db/id',
    res.temp_board_share_token_id
  )({ ':board-share-token/value': value, ':board-share-token/enabled': true })
  dispatch({
    type: actions.ADD_BOARD_SHARE_TOKEN,
    payload: realNewToken
  })
}

export const toggleShareToken = token => async (dispatch, getState) => {
  const state = getState()
  const boardId = selectors.boardIdSelector(state)

  await transact(
    [['@board/toggle-share-token', { boardId, tokenId: token[':db/id'] }]],
    { alwaysThrow: true }
  )
  dispatch({
    type: actions.TOGGLE_BOARD_SHARE_TOKEN,
    payload: token[':db/id']
  })
}
